import {
    GAME_URL,
    GET_STUDENT,
    GET_SAVED_RESPONSE_SUCCESS,
    GET_SAVED_RESPONSE_FAIL,
} from '../constants';
import axios from 'axios';

axios.defaults.withCredentials = true;
window.getSavedSessionCalled = false;

export const getStudent = (id) => {
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    const readingTimeUrl = `${GAME_URL}/students/${person?.info?.personId}`;
    const playTimeUrl = `${GAME_URL}/students/${person?.info?.personId}/play-time`;
    return async (dispatch, getState) => {
        const state = getState();

        const studentsConfig = {
            headers: {
                'access-token': `${state.platform.auth.token}`
            }
        }

        const playTimeConfig = {
            headers: {
                'access-token': `${state.platform.auth.token}`
            }
        }
        axios.all([
            axios.get(readingTimeUrl, studentsConfig),
            axios.get(playTimeUrl, playTimeConfig)
        ])
            .then(axios.spread((...responses) => {
                const responseOne = responses[0]
                const responseTwo = responses[1]
                // use/access the results 
                console.log("getStudent res", responseOne.data, responseTwo.data)
                dispatch({
                    type: GET_STUDENT,
                    studentHistory: responseOne.data,
                    playTime: responseTwo.data
                })
            }))
            .catch(err => console.log(err))
    }
};

export const getSavedSession = (bookId) => {
    console.log('getsavedSession called')
    window.getSavedSessionCalled = true;
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);


    const url = `${GAME_URL}/buddy-books/save/student/${person?.info?.personId}?bookId=${bookId}`;
    return async (dispatch, getState) => {
        const state = getState();
        const config = {
            url,
            headers: {
                'access-token': `${state.platform.auth.token}`
            }
        }
        try {
            var res = await axios(config);
            dispatch({
                type: GET_SAVED_RESPONSE_SUCCESS,
                payload: res.data,
                currentSection: null
            });
            console.log('getSavedSession Succes Res', res);
        } catch (err) {
            console.log('getSavedSession catch', err.response);
            dispatch({
                type: GET_SAVED_RESPONSE_FAIL,
            })
        }
    }
}
